import { useSelector } from 'react-redux';

import useScreenSize from '@swf/core/hooks/useScreenSize';
import { select } from '@swf/core/store';
import { mobileBreakpoint } from '@swf/core/utils';

const useIsDesktop = () => {
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const { greaterThan } = useScreenSize();
  return isDesktopEmbedded || greaterThan(mobileBreakpoint);
};

export default useIsDesktop;
